import { Fragment, useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Box, Button, EmptyState } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { PromptLibraryDialog } from 'app/domains/prompt-library';
import { SelectPrompt } from './SelectPrompt';
export function InitialState(props) {
    const { onSelectPrompt } = props;
    const [promptLibraryOpen, setPromptLibraryOpen] = useState(false);
    const openPromptLibrary = () => setPromptLibraryOpen(true);
    const closePromptLibrary = () => setPromptLibraryOpen(false);
    return (<Fragment>
      <EmptyState withAvatar icon={<Falcon icon="eye"/>} title={t({
            comment: 'Document approval check - Approval might be needed title',
            message: 'Approval might be needed',
        })} description={t({
            comment: 'Document approval check - Approval might be needed description',
            message: 'This document might need internal approval before sending for eSigning',
        })} actions={<Box flexDirection="column" alignItems="center" gap="md">
            <SelectPrompt onSelect={onSelectPrompt}/>
            <Button appearance="ghost" size="small" onClick={openPromptLibrary}>
              <Falcon icon="book-bookmark"/>
              <Trans comment="Document approval check - Prompt library button label">Prompt library</Trans>
            </Button>
          </Box>}/>
      {promptLibraryOpen && (<PromptLibraryDialog defaultView="library" onSelect={closePromptLibrary} onClose={closePromptLibrary}/>)}
    </Fragment>);
}
